import type { Response } from '@/types/common';
import { message } from 'ant-design-vue';
import type { AxiosError, AxiosResponse } from 'axios';

/**
 * @description: 响应拦截器
 */
function responseInterceptor(response: AxiosResponse): Response | null {
  if (response.data.code === 0 || response.data.code === 10100) {
    return response.data;
  } else {
    response.data.msg?.length > 0 && message.error(response.data.msg);
    return response.data;
  }
}

/**
 * @desc: 异常拦截处理器
 */
function errorHandler(error: AxiosError): AxiosError | Promise<AxiosError> {
  error.message?.length > 0 && message.error(error.message);
  return Promise.reject(error);
}

export default {
  responseInterceptor,
  requestErrorHandler: errorHandler,
  responseErrorHandler: errorHandler,
};
